<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" role="graphics-symbol" class="circle__svg">
    <circle class="circle__svg-circle" cx="50" cy="50" r="45" />
  </svg>
</template>

<style lang="scss" scoped>
.circle__svg {
  animation: 2s linear infinite both circle__svg-animation;
}

@keyframes circle__svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

.circle__svg-circle {
  animation: 1.4s ease-in-out infinite both circle__svg-circle;
  fill: transparent;
  stroke-dasharray: 285;
  stroke-linecap: round;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

@keyframes circle__svg-circle {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
